import { React, useEffect } from "react";
import styles from "./RecycleBin.module.scss";
import FileCard from "../FIleCard/FileCard";

import Loader from "../Loader/Loader";

import { useSelector, useDispatch } from "react-redux";

import { fetchDeletedFiles } from "../service/apiService";
import { fetchFilesRequest } from "../../Redux/Files/FileActions";

function RecycleBin(props) {
  const dispatch = useDispatch();
  const deletedFilesData = useSelector((state) => state.allFiles);
  const userData = useSelector((state) => state.user);
  let userId = userData && userData.userId && userData.userId;

  useEffect(() => {
    dispatch(fetchFilesRequest());
    dispatch(fetchDeletedFiles(userId));
  }, []);

  return deletedFilesData && deletedFilesData.loading ? (
    <div>
      <Loader />
    </div>
  ) : (
    <>
      {/* <ShortMSG /> */}
      {deletedFilesData &&
      deletedFilesData.deletedFiles &&
      deletedFilesData.deletedFiles.length !== 0 ? (
        <div className={`container ${styles.deletedFileList}`}>
          {deletedFilesData &&
            deletedFilesData.deletedFiles &&
            deletedFilesData.deletedFiles.map((file) => {
              return (
                <FileCard
                  key={file._id}
                  file={file}
                  filesList={
                    deletedFilesData &&
                    deletedFilesData.deletedFiles &&
                    deletedFilesData.deletedFiles
                  }
                  impHandler={props.impHandler}
                  deleteHandler={props.deleteHandler}
                  page={"bin"}
                />
              );
            })}
        </div>
      ) : (
        <h1 className={styles.noFileMessage}> Your bin is empty </h1>
      )}
    </>
  );
}

export default RecycleBin;
